import { FaUser } from "react-icons/fa";

export const UserIcon = ({ ...rest }) => {
  return <FaUser {...rest} />;
};
